<template>
  <el-dialog
    v-model="showConsent" 
    title=" "
    width="40%"
    :close-on-click-modal="false" 
    :before-close="handleClose"
    :visible.sync="showConsent"
    :show-close="false"
    center
  >
    <!-- 整体居中div -->
    <div style="text-align: center;">
      <img src="@/assets/img/cookie.svg" alt="cookie" style="width: 100px; height: 100px; display: block; margin: 0 auto; margin-bottom: 20px;">
      <h3 style="color:black; display: block; margin: 0 auto; margin-bottom: 20px;" ><b>About cookies</b></h3>
        <div style="
          max-width: 90%;
          margin: 0 auto;
          text-align: center;
          color: #444;
          font-size: 14px;
          line-height: 1.7;
          word-break: normal;
          overflow-wrap: normal;
          hyphens: none;
        ">
          <p style="margin-bottom: 14px;">
            Our website places a high value on protecting your privacy.
          </p>

          <p style="
            margin-bottom: 14px;
            font-weight: 600;
            color: #222;
          ">
            We do not use cookies to collect or store any personal information.
          </p>

          <p style="margin-bottom: 14px;">
            We provide a high-quality browsing experience through alternative
            technical solutions, while ensuring that your data security and
            privacy are fully respected. You may browse this website with confidence, without concerns
            regarding cookie-related privacy issues.
          </p>
        </div>
    </div>
    <template #footer>
      <!-- <el-button @click="rejectCookies" type="warning"><b>Reject</b></el-button> -->
      <el-button @click="acceptCookies" type="primary"><b>Continue</b></el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      showConsent: false,  // 控制弹框显示
    };
  },
  created() {
    // console.log("cookieConsent in localStorage:", localStorage.getItem("cookieConsent"));
    // 检查是否有用户同意信息
    const consent = localStorage.getItem("cookieConsent");
    if (consent != "accepted") {
      this.showConsent = true;  // 如果没有同意，显示弹框
    }
  },
  methods: {
    acceptCookies() {
      localStorage.setItem("cookieConsent", "accepted");  // 存储同意状态
      this.showConsent = false;  // 隐藏弹框
    },
    handleClose(done) {
      done();
    },
    rejectCookies() {
      localStorage.setItem("cookieConsent", "rejected");  // 存储拒绝状态
      this.showConsent = false;  // 隐藏弹框
    },

  },
};
</script>

<style scoped>
.el-dialog {
  z-index: 9999;
}

/* Custom styling for the dialog to appear at the bottom */
.cookie-consent-dialog .el-dialog__wrapper {
  position: fixed;
  bottom: 20px;  /* Adjust distance from the bottom */
  left: 50%;
  transform: translateX(-50%);
  margin: 0; /* Remove any default margin */
}
</style>
